import { useMemo } from 'react';
export const useHistory = () => {
    return useMemo(() => {
        return {
            push: (path) => {
                window.history.pushState(null, null, path);
            },
        };
    }, []);
};
